import { Component, OnInit } from '@angular/core';
import { DeletePaymentsService } from 'src/app/services/transactions/delete-payments.service';

@Component({
  selector: 'app-delete-nema-payments',
  templateUrl: './delete-nema-payments.component.html',
  styleUrls: ['./delete-nema-payments.component.css']
})
export class DeleteNemaPaymentsComponent implements OnInit{
  page: number = 1;
  count: number = 0;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  deletablePayments: any[] = [];
  searchText: string = '';
  public isLoading: boolean = false;
  isProcessing: boolean = false;
  submitted: boolean = false;
  public entry_id:string='';
  public txn_id:string='';

  constructor(
        private deletePaymentsService: DeletePaymentsService
      ){

      }

  ngOnInit(): void {
    this.isLoading=true;
    this.getDeletableNEMA_Payments();
  }

  getDeletableNEMA_Payments(): void {
    this.deletePaymentsService.fetchNEMA_Payments()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.deletablePayments = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isLoading=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }

  deleteNEMA_Payment(row_id:number,vehicle_id: string,chassis_no: string,amount: number){
    this.errorMessage=null;
    this.successMessage=null;

    let prompt = "Are you sure you want to delete NEMA payment for vehicle with chassis number "+chassis_no+"?";
    if (confirm(prompt) == true) {
      this.isLoading=true;
      this.deletePaymentsService.deleteNEMA_Payment(row_id,vehicle_id,chassis_no,amount)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.successMessage =response.message;
            this.getDeletableNEMA_Payments();
          }else{
            this.errorMessage=response.message;
            this.isLoading=false;
          }
        },
        error: (error) => {
          this.errorMessage=error;
          this.isLoading=false;
        }
      });
    }
  }
}
